
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.889 15.454v-4.168l1.15 1.175 1.256-1.286L8 7.805l-3.295 3.37 1.257 1.286 1.15-1.175v4.168h1.777z","fill":"#FCB269"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.035 0H1.778C.796 0 0 .814 0 1.818v16.364C0 19.186.796 20 1.778 20h12.444c.982 0 1.778-.814 1.778-1.818V5.078L11.035 0zM1.778 1.818h7.11v3.637c0 1.004.797 1.818 1.779 1.818h3.555v10.909H1.778V1.818zm8.889 3.637v-3.26l3.187 3.26h-3.187z","fill":"#FCB269"}})])
          )
        }
      }
    